import { Observable } from 'rxjs';

// Lets AuthService reach UserState (feature lib) without an import; apps provide it where UserState was registered in NGXS
export abstract class AuthUserState {
  abstract loadUser(): Observable<void>;
  abstract loadLoggedInUser(): Observable<void>;
  abstract resetUser(): void;
}
